export default class {

  constructor(global) {
    this.global = global;

    window.addEventListener('DOMContentLoaded', () => {
      this.initHandle();
    });
    if (window.frameworkInitialised || document.readyState !== 'loading') {
      this.initHandle();
    }    
  }

  initHandle() {
    if (this.hasExecutedInit) {
      return;
    }
    this.hasExecutedInit = true;
    this.init();
  }
  init() {
    // Override if you want to run init functions when thepage has loaded 
  }
}